import getVariable from "~utils/getVariable";
import { urlSearchParamsFromQueryObject } from "~utils/searchParams";

const externalUrlPrefixes = ["#", "http", "mailto:", "tel:"];

export const toValidUrl = (url) => {
  if (!url || typeof url !== "string") {
    return "";
  }

  if (
    !url.startsWith("/") &&
    externalUrlPrefixes.every((prefix) => !url.startsWith(prefix))
  ) {
    // if the url is not external, make sure it starts with a slash
    return `/${url}`;
  }
  // make sure url does not start with multiple slashes
  return url.replace(/^\/+/, "/");
};

/**
 * @param {string} path
 * @param {object} options
 * @param {string} options.locale
 * @param {string} options.defaultLocale
 * @param {boolean} [options.absolute=false]
 * @param {object} [options.query={}]
 * @returns {string}
 */
export const resolveUrl = (
  path,
  { locale, defaultLocale, absolute = false, query = {} },
) => {
  const urlSearchParams = urlSearchParamsFromQueryObject(query);
  const prefix = absolute ? getVariable("baseUrl") : "";
  const suffix =
    urlSearchParams.size > 0 ? `?${urlSearchParams.toString()}` : "";
  if (!locale || locale === defaultLocale) {
    return `${prefix}${path}${suffix}`;
  }
  if (!path || path === "/") {
    return `${prefix}/${locale}${suffix}`;
  }
  return `${prefix}/${locale}/${path.replace(/^\/+/, "")}${suffix}`;
};
